module.exports = __webpack_public_path__ + "static/media/tarja.2b5714fc.svg";